<template>
  <f-modal
    ref="video-tag-popup-modal"
    :class="{ 'is-visible': isVisible }"
    @close="handleClose">
    <f-modal-header>
      <h3 class="heading-medium">
        <template v-if="editMode">
          Edit Tag
        </template>
        <template v-else>
          New Tag
        </template>
      </h3>
    </f-modal-header>

    <f-modal-body>
      <validation-observer
        ref="video-tag-popup-form"
        tag="form"
        @keydown.enter.prevent>

        <div class="form-group">
          <label for="name">
            Name
          </label>

          <validation-provider
            rules="required"
            name="name"
            v-slot="{ errors }">
            <input
              class="full-width"
              type="text"
              v-model="data.name"
              :state="errors.length ? 'invalid' : null"/>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>

      </validation-observer>

    </f-modal-body>
    <f-modal-footer>
      <div class="flex flex-justify-content-between">
        <f-button
          class="ml-0 btn btn-danger"
          theme="danger"
          @click.prevent="handleClose">
          Cancel
        </f-button>
        <f-button
          class="ml-auto btn btn-primary"
          theme="primary"
          :disabled="submitInProgress"
          @click.prevent="validateForm">
          <div
            v-if="submitInProgress"
            class="loading-spinner"
            role="status">
          </div>
          <template v-if="editMode">Save changes</template>
          <template v-else>Add</template>
        </f-button>
      </div>
    </f-modal-footer>
  </f-modal>
</template>
<script>
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'video-tag-popup',
  computed: {
  },
  data() {
    return {
      data: {
        id: 0,
        name: '',
      },
      isVisible: false,
      editMode: false,
      submitInProgress: false
    };
  },
  mounted() {
    this.$bus.$on('video-tag-popup-show', this.openPopup);
  },
  methods: {
    handleClose() {
      document.body.classList.remove('no-scroll');
      this.isVisible = false;
    },
    openPopup(tag = null) {
      this.editMode = !!tag;

      if (this.editMode) {
        this.data.id = tag.id;
        this.data.name = tag.name;
      } else {
        this.data.id = 0;
        this.data.name = '';
      }

      setTimeout(() => {
        this.isVisible = true;
        this.submitInProgress = false;
        document.body.classList.add('no-scroll');

        if (this.$refs['video-tag-popup-form']) {
          this.$refs['video-tag-popup-form'].reset();
        }
      }, 0);
    },
    validateForm () {
      FormUtils.validate(this.$refs['video-tag-popup-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.editMode ? '/api/video/tag/update/' + this.data.id : '/api/video/tag/add';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Tag saved',
        successText: 'This tag has been saved',
        errorTitle: 'An error has occurred',
        errorText: 'Modification of an entry has failed. Please try again.',
        successAction: () => {
          this.$bus.$emit('videos-tags-reload');
          this.handleClose();
        }
      });
    },
    prepareFormDataToSend () {
      return {
        name: this.data.name
      };
    },
  },
  beforeDestroy () {
    this.$bus.$on('video-tag-popup-show', this.openPopup);
  }
}
</script>
